export default __webpack_public_path__ + "static/media/about.8e079963.jpg";